import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { CommentConfirmDialog } from 'scenes/IO/components/CommentConfirmDialog';
import { addCommentIo } from 'scenes/IO/sources/io';

import { addComment } from '../queryKeyFactory';

export const useCommentIO = (io) => {
  const showModal = useScreenModalV2(CommentConfirmDialog);
  const addCommentMutation = useMutation(addComment(), addCommentIo, {
    successMessage: () => `Comment added`,
  });

  const handleAction = async () => {
    const { comment } = await showModal({
      io,
    });

    await addCommentMutation.mutateAsync({ id: io.id, comment });
  };

  return [handleAction, addCommentMutation];
};
